export default __webpack_public_path__ + "e252000a3bbe8ec6d20b6b82e02e0778.png";